import { useCallback, useMemo } from "react"
import {loadStripe} from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { getCheckoutSession } from "@/services/checkout.service"
import { useLocation, useNavigate } from "react-router"
import { Button, Result } from "antd"
const pk = process.env.REACT_APP_STRIPE_KEY || ''

export const Checkout = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const plan = location.state?.plan;

  const stripePromise = useMemo(() => {
    return loadStripe(pk);
  }, [])

  const fetchClientSecret = useCallback(() => {
    return getCheckoutSession(plan).then(res => res.clientSecret)
  }, [plan]);

  const goPricing = () => {
    navigate('/pricing')
  }

  if (!plan) {
    return <Result
    status="warning"
    title="Please choose a plan to continue"
    extra={
      <Button type="primary" onClick={goPricing}>
        Go Pricing
      </Button>
    }
  />
  }

  const options = {fetchClientSecret};
  
  return <div style={{width: '100%', height: '100%'}}>
    <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={options}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
  </div>
}